import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Clock, Brain, BatteryWarning } from 'lucide-react';
export function PainSection() {
  return <section className="py-12 md:py-20 px-4 bg-forest-800 relative overflow-hidden" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <div className="text-center mb-8 md:mb-16" data-id="element-87">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-gold-500 mb-6" data-id="element-88">
            ¿Te Suena Familiar?
          </motion.h2>
          <div className="w-24 h-1 bg-forest-500 mx-auto rounded-full" data-id="element-89" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 items-center" data-id="element-90">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-4 md:space-y-6" data-id="element-91">
            <p className="text-base md:text-xl text-cream-200 leading-relaxed" data-id="element-92">
              Tú, oficinista en México o Colombia, entre 30 y 50 años.
              Despiertas a las{' '}
              <span className="text-gold-400 font-bold" data-id="element-93">3:00 AM</span> empapado
              en sudor frío.
            </p>
            <p className="text-base md:text-xl text-cream-300 leading-relaxed" data-id="element-94">
              Tu corazón palpita fuerte. Repasas deadlines infinitos. No puedes
              regresar al sueño. Mañana tienes junta a las 9 AM y serás un{' '}
              <span className="italic text-cream-100" data-id="element-95">zombie cafeinado</span>.
            </p>
            <p className="text-base md:text-xl text-cream-300 leading-relaxed" data-id="element-96">
              El estrés laboral te roba 3-4 horas cada noche. Tus hijos esperan
              un papá o mamá alerta, pero tu pareja solo nota tu irritabilidad.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-forest-700 border border-forest-500 rounded-xl p-5 md:p-8 shadow-xl relative" data-id="element-97">
            <div className="absolute -top-4 -right-4 bg-gold-500 text-forest-900 p-3 rounded-full shadow-lg" data-id="element-98">
              <Moon className="w-6 h-6 fill-current" data-id="element-99" />
            </div>

            <ul className="space-y-4 md:space-y-6" data-id="element-100">
              <li className="flex items-start gap-4" data-id="element-101">
                <Clock className="w-6 h-6 text-gold-500 shrink-0 mt-1" data-id="element-102" />
                <div data-id="element-103">
                  <h4 className="font-serif text-cream-100 text-lg mb-1" data-id="element-104">
                    Insomnio de mantenimiento
                  </h4>
                  <p className="text-cream-300 text-sm" data-id="element-105">
                    Despiertas a media noche y tu mente se enciende
                    automáticamente.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-106">
                <Brain className="w-6 h-6 text-gold-500 shrink-0 mt-1" data-id="element-107" />
                <div data-id="element-108">
                  <h4 className="font-serif text-cream-100 text-lg mb-1" data-id="element-109">
                    Rumiación mental
                  </h4>
                  <p className="text-cream-300 text-sm" data-id="element-110">
                    No puedes apagar los pensamientos sobre pendientes y
                    problemas.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-111">
                <BatteryWarning className="w-6 h-6 text-gold-500 shrink-0 mt-1" data-id="element-112" />
                <div data-id="element-113">
                  <h4 className="font-serif text-cream-100 text-lg mb-1" data-id="element-114">
                    Agotamiento crónico
                  </h4>
                  <p className="text-cream-300 text-sm" data-id="element-115">
                    Vives cansado pero "alerta", incapaz de descansar de verdad.
                  </p>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}